import * as styles from '@rdcomponents/maintenance-banner/maintenance-banner.scss';
import {useMaintenanceBanner} from '@rdcomponents/maintenance-banner/use-maintenance-banner';
import {Alert} from 'antd';

export function MaintenanceBanner(): JSX.Element | null {
    const {isVisible, message} = useMaintenanceBanner();

    if (!isVisible || !message) {
        return null;
    }

    return <Alert className={styles.MaintenanceBanner} message={message} showIcon type="warning" />;
}
